import { render, staticRenderFns } from "./RecipeStep3.vue?vue&type=template&id=39da74b9&scoped=true"
import script from "./RecipeStep3.vue?vue&type=script&lang=js"
export * from "./RecipeStep3.vue?vue&type=script&lang=js"
import style0 from "./RecipeStep3.vue?vue&type=style&index=0&id=39da74b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39da74b9",
  null
  
)

export default component.exports